import React, { useEffect, useRef, useState } from 'react';
import { ChevronLeft, ChevronRight } from "lucide-react";
import bg3 from '../imgs/dia-diem-du-lich-he-7.jpeg';
import codung from '../imgs/codung.png';
import maichau from '../imgs/maichau.png';
import cohy from '../imgs/cohy.png';
import socson from '../imgs/socson.jpg';
import sapa from '../imgs/sapa.png';
import maichau2 from '../imgs/maichau.jpg';


const data = [
    {
        title: 'Co Dung Heron Eco-Retreat',
        location: 'Thach That, Hanoi City.',
        size: '3 hectare',
        deployment: 'June 2021',
        img: codung
      },
      {
        title: 'Vinh Hy Rest Stop',
        location: 'Vinh Hy Bay',
        size: '4 hectare',
        deployment: 'August 2021',
        img: cohy
      },
      {
        title: 'Mai Chau – Sol Bungalows Resort',
        location: 'Mai Chau, Phu Tho Province',
        size: '8000 m2',
        deployment: 'Dec 2021',
        img: maichau
      },
      {
        title: 'Paradise Soc Son Resort',
        location: 'Soc Son, Ha Noi City',
        size: '8 hectare',
        deployment: 'May 2024',
        img: socson
      },
      {
        title: 'Sapa Destination',
        location: 'Sapa, Lao Cai Province',
        size: '5,2 hectare',
        deployment: 'Dec 2021',
        img: sapa
      },
      {
        title: 'Jade de Mai Chau',
        location: 'Phu Tho Province',
        size: '6 hectare',
        deployment: '2023',
        img: maichau2
      },
];
const Slider = () => {

    const [currentIndex, setCurrentIndex] = useState(1);
    const intervalRef = useRef(null);

    const nextSlide = () => {
        setCurrentIndex((prev) => (prev + 1) % data.length);
    };

    const prevSlide = () => {
        setCurrentIndex((prev) => (prev - 1 + data.length) % data.length);
    };

    useEffect(() => {
        intervalRef.current = setInterval(() => {
            nextSlide();
        }, 3000);

        return () => clearInterval(intervalRef.current);
    }, []);

    const getVisibleItems = () => {
        const items = [
            data[(currentIndex - 1 + data.length) % data.length],
            data[currentIndex],
            data[(currentIndex + 1) % data.length]
        ];
        return items;
    };
    return (
        <section className="relative bg-[#0B1D26] py-20 h-[843px] hidden md:block">
            <div className="absolute inset-0 z-10 bg-gradient-to-b from-[#0B1D26] via-[#0B1D26]/50 to-[#0B1D26]/0" />

            <div className="absolute inset-0 z-10 bg-gradient-to-t from-[#0B1D26] via-[#0B1D26]/20 to-transparent" />
            {/* Background overlay if needed */}
            <div className="absolute inset-0 z-0">
                <img
                    src={bg3}
                    alt="background"
                    className="w-full h-full object-cover"
                />
            </div>

            {/* Title */}
            <div className="relative h-[40px] flex items-center mb-4 w-full mt-[20px]  " style={{ marginLeft: 70 }}>
                {/* Chữ mờ lớn phía sau */}
                <h2 className="absolute text-[90px] font-bold text-white/5 uppercase leading-none z-10 select-none">
                    OUR PROJECTS
                </h2>

                {/* Chữ nhỏ phía trước */}
                <div className="relative z-10 flex items-center space-x-3 top-[10px]">
                    <div className="w-[30px] h-0.5 bg-yellow-400"></div>
                    <h3 className="text-yellow-400 uppercase tracking-widest text-[22px] font-semibold">
                        OUR PROJECTS
                    </h3>
                </div>
            </div>

            {/* Product Cards */}
            <div className="relative z-10 max-w-7xl mx-auto px-4 top-[100px]">
                <div className="relative flex items-center justify-between bg-white/5 backdrop-blur-md rounded-2xl p-6 overflow-hidden w-full border border-white/20 h-[304px] ">
                    {/* Left Arrow */}
                    <button
                        onClick={prevSlide}
                        className="w-11 h-11 flex items-center justify-center text-white bg-white/20 hover:bg-white/30 rounded-full z-10"
                    >
                        <ChevronLeft className="w-5 h-5" />
                    </button>

                    {/* Product Items */}
                    <div className="flex justify-center items-center gap-8 w-full overflow-hidden px-4 transition-transform duration-700 ease-in-out">
                        {getVisibleItems().map((item, index) => (


                            <div
                                key={index}
                                className="bg-[#0B1D26]/60 hover:bg-white/10 transition duration-300 
           backdrop-blur-xl rounded-2xl border border-white/10 
           w-[366px] h-[256px] flex text-white p-4"
                            >
                                <div className="w-[150px] h-[150px] flex flex-col">
                                    <img
                                        src={item.img}
                                        alt={item.title}
                                        className="rounded-xl w-[150px] h-[150px] aspect-square object-cover mb-3"
                                    />
                                </div>

                                <div className="ml-4 flex flex-col justify-start">
                                    <h4 className="font-semibold text-base leading-snug mb-3 text-left">
                                        {item.title}
                                    </h4>
                                    <ul className="text-sm list-disc list-outside pl-6 space-y-2 text-white text-left">
                                        <li className="leading-relaxed">Location: {item.location}</li>
                                        <li className="leading-relaxed">Size: {item.size}</li>
                                        <li className="leading-relaxed">Deployment time: {item.deployment}</li>
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Right Arrow */}
                    <button
                        onClick={nextSlide}
                        className="w-11 h-11 flex items-center justify-center text-white bg-white/20 hover:bg-white/30 rounded-full z-10"
                    >
                        <ChevronRight className="w-5 h-5" />
                    </button>
                </div>
            </div>
        </section>
    )
}

export default Slider